import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Whychooseunreal() {
  return (
    <section className="why_choose_unreal p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="order-2 order-md-1 mt-3 mt-md-0"
          >
            <StaticImage
              src="../../images/services-usa/unreal-game-update/why_choose_unreal.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={682}
              height={642}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 order-1 order-md-2"
          >
            <h2>
              Why Choose TekRevol as Your <span>Unreal Game Development</span>{" "}
              Company?
            </h2>
            <p>
              Our Unreal Engine game development company stands out due to our
              technical expertise, precision, and commitment to delivering
              high-performance games. We excel across the entire development
              cycle, from strategic planning to deployment and ASO, ensuring
              each phase is executed with precision. Our collaborative
              engagement model keeps you involved, providing transparency and
              alignment with your vision. We deliver intuitive, visually
              stunning, and optimized games that resonate with players. With a
              robust tech stack and a focus on innovation, we ensure every
              project meets the highest standards of quality and performance,
              driving your game's success in the market.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Build My Game
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseunreal;
